import Injector from '@slickdeals/durango/dist/javascript/core/injector';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
/** The name of the module */
export const name = 'DataHydration';
/** Global hydration queue */
window.bpHydration = window.bpHydration || [];
/**
 * All the hydration data being stored. Keys on the object are the name of a module (e.g. PagedCarousel), which
 * is an array of data for each instance of that module on the page
 *
 * @type {Object}
 * @property {String} hydrationData.{moduleName}
 */
// Disabling the any here because the hydration can be of any value
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hydrationData = {};
/**
 * Determines if sent parameter is of type string
 *
 * @param {string | any} key Object to verify type
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isKey = (key) => typeof key === 'string';
/**
 * Determines if sent parameter is of type string[]
 *
 * @param {string[] | any} keyArray Object to verify type
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isKeyArray = (keyArray) => (Array.isArray(keyArray)
    && !!keyArray.length
    && keyArray.every(isKey));
/**
 * Loops through an array of hydration data and hydrates everything through the Injector
 * @param key Module name to hydrate
 * @param data Hydration Data
 */
export function instantiate(key, data) {
    // Loop through the data and instantiate an object for each data item in the array
    data.forEach((componentOptions, index) => {
        if (isKeyArray(key)) {
            // Instantiate the object through DI
            Injector.resolve(key[index], componentOptions[key[index]]);
            return;
        }
        if (isKey(key)) {
            // Instantiate the object through DI
            Injector.resolve(key, componentOptions);
            return;
        }
        Logger.warn(`Invalid hydration key: ${key}`);
    });
}
export function getHydrationKeys(data) {
    return data.map((componentOptions) => Object.keys(componentOptions)[0]);
}
/**
 * Take data that was added to the hydration queue and add it to the final hydration data variable
 *
 * @param {Object} data - Object keyed by module name with data to hydrate
 */
// Disabling the any here because the hydration can be of any value
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function parseHydrationData(data) {
    Object.keys(data).forEach((key) => {
        if (key in hydrationData) {
            hydrationData[key].push(data[key]);
        }
        else {
            hydrationData[key] = [data[key]];
        }
    });
}
/**
 * Fetch the hydration data for a particular module (key)
 *
 * @param {String} [key=''] - A key representing the module's data being requested
 *
 * @returns {Object[]|Object}
 */
// Disabling the any here because the hydration can be of any value
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getHydrationData(key = '') {
    if (key && key in hydrationData && Array.isArray(hydrationData[key])) {
        return hydrationData[key];
    }
    if (!key) {
        return hydrationData;
    }
    return [];
}
/**
 * Function called when the module is executed to parse existing hydration in queue and redefine the queue's .push()
 * function to call parseHydrationData directly instead of adding to the queue.
 */
function hydrate() {
    window.bpHydration.forEach(parseHydrationData);
    window.bpHydration.push = parseHydrationData;
}
// Hydrate any existing data already pushed into queue
hydrate();
